import axios from 'axios';
import { useQuery } from 'react-query';
import { useAxios } from 'shared/hooks';
/**
 * Gets a list of diagnosis codes for given search terms.  Disabled if terms is null.
 */
export var useSelectDiagnosisCodes = function (terms) {
    var axiosInstance = useAxios();
    return useQuery(['select-diagnosis-codes', terms], function () {
        var source = axios.CancelToken.source();
        var promise = axiosInstance
            .get("/api/v1/diagnosis_codes/search?terms=".concat(terms), {
            cancelToken: source.token,
        })
            .then(function (res) { return res.data.data; });
        promise.cancel = function () {
            source.cancel('Query cancelled');
        };
        return promise;
    }, {
        enabled: !!terms,
        keepPreviousData: !!terms,
    });
};
